import React from 'react';
import './SupportingTeam.css';

const SupportingTeam = () => {
  // Added 'profileUrl' to each member. Replace the '#' with their actual LinkedIn or portfolio URLs.
  const teamMembers = [
    {
      id: 1,
      name: 'Karthikeya Pabbathi',
      profileUrl: 'https://linkedin.com/in/pabbathikarthikeya'
    },
    
    {
      id: 2,
      name: 'Karthik Meda',
      profileUrl: 'https://www.linkedin.com/in/karthik-meda/'
    },
    {
      id: 3,
      name: 'Nihitha Narreddy',
      profileUrl: 'https://www.linkedin.com/in/narreddy-nihitha-394882246/'
    },
    {
      id: 4,
      name: 'Medhavathi Kummetha',
      profileUrl: 'https://www.linkedin.com/in/kummetha-medhavathi-b7bb58246/' 
    },
    
    {
      id: 5,
      name: 'Lokavardhan Reddy Kanchanagari',
      profileUrl: 'https://www.linkedin.com/in/kanchanagari-lokavardhanreddy-537702247/'
    },
    {
      id: 6,
      name: 'Kousalya Asam',
      profileUrl: 'https://www.linkedin.com/in/asam-kousalya-982353247/'
    },
    {
      id: 7,
      name: 'Siva Manikanta Reddy',
      profileUrl: 'https://www.linkedin.com/in/asam-siva-manikanta-reddy-089a61251/'
    }

  ];

  return (
    <section className="supporting-team">
      <div className="team-container">
        <h2 className="team-title">Our Supporting Team</h2>
        <p className="team-subtitle">Meet the talented professionals driving TrekVerse forward</p>
        
        <div className="team-grid">
          {teamMembers.map((member) => (
            <div key={member.id} className="team-card text-only-card">
              <div className="team-info">
                <h3 className="team-name">{member.name}</h3>
                <p className="team-company">{member.company}</p>
                
                {/* The new redirect link */}
                <a 
                  href={member.profileUrl} 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="profile-link-btn"
                >
                  View Profile ↗
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SupportingTeam;